import { createMuiTheme } from '@material-ui/core'

export const bmsTheme = theme =>
	createMuiTheme({
		palette: {
			primary: {
				main: theme.primary(theme).backgroundColor,
				light: theme.primary(theme).backgroundColor,
				dark: theme.primary(theme).backgroundColor,
			},
			secondary: {
				main: theme.primary(theme).backgroundColor,
			},
		},
	})

export const __title = ({ theme }) => ({
	fontSize: theme.font.size12,
	color: theme.primary(theme).formTextColor,
})

export const __wrapper = ({
	disabled,
	theme,
	width,
	minWidth,
	unsetWrapperPadding,
}) => ({
	paddingBottom: theme.spaces['8'],
	opacity: disabled ? '0.5' : '1',
	extend: [
		{
			condition: width,
			style: {
				width,
			},
		},
		{
			condition: minWidth,
			style: {
				minWidth,
			},
		},
		{
			condition: unsetWrapperPadding,
			style: {
				padding: '0 !important',
			},
		},
	],
})

export const __select = () => ({
	padding: '8px 31px 8px 12px !important',
})
